<script setup lang="ts">
import { computed } from 'vue';

import { useTenantStore } from '@/stores/tenant';

import MCPConnectorsSection from './mcp-connector-ui/MCPConnectorsSection.vue';
import MicrosoftSection from './MicrosoftSection.vue';

const tenantStore = useTenantStore();

// The Microsoft card holds the tenant's Azure app secret and grants for the whole
// organisation; MCP connectors are per-user.
const isAdmin = computed(() => tenantStore.tenantAdmin);
</script>

<template>
    <div class="mt-0 space-y-6">
        <div class="space-y-2">
            <h2 class="text-xl font-semibold">Connections</h2>
            <p class="text-sm text-muted-foreground">
                Connected apps and external services.
            </p>
        </div>

        <MCPConnectorsSection />
        <MicrosoftSection v-if="isAdmin" />
    </div>
</template>
